import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css';
import useWindowSize from 'utils/hooks/useWindowSize';
import styles from 'styles/pages/DigitalTools/CargoesFlow/CargoesFlow.module.scss';

const cn = classNames.bind(styles);

const SectionSaas = (): ReactElement => {
  const { width } = useWindowSize();

  const navigationNext = React.useRef(null);
  const navigationPrev = React.useRef(null);

  return (
    <section className={cn('sass')}>
      <div className={cn('container')}>
        <div className={cn('sass__title-box')}>
          <img
            className={cn('sass__title-icon', 'highlight')}
            src="/images/pages/DigitalTools/CargoesFlow/icon-highlight.svg"
            alt="icon"
          />
          <h2 className={cn('sass__title')}>SAAS based solution</h2>
          <img
            className={cn('sass__title-icon', 'mark')}
            src="/images/pages/DigitalTools/CargoesFlow/icon-mark.svg"
            alt="icon"
          />
        </div>
        <div className={cn('sass__slider-box')}>
          {width > 0 && (
            <Swiper
              modules={[Navigation, Autoplay]}
              loop={false}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
              }}
              spaceBetween={50}
              slidesPerView={1}
              navigation={{
                prevEl: navigationPrev.current,
                nextEl: navigationNext.current,
              }}
              onBeforeInit={(swiper: any) => {
                swiper.params.navigation.prevEl = navigationPrev.current;
                swiper.params.navigation.nextEl = navigationNext.current;
              }}
              breakpoints={{
                // when window width is >= 320px
                375: {
                  slidesPerView: 1,
                  spaceBetween: 50,
                },
                // when window width is >= 480px
                // when window width is >= 640px
                1200: {
                  slidesPerView: 1,
                  spaceBetween: 50,
                },
              }}
            >
              <SwiperSlide>
                <div className={cn('sass__slide')}>
                  <img
                    src="/images/pages/DigitalTools/CargoesFlow/management.png"
                    alt="calendar management"
                    className={cn('sass__slide-image')}
                  />
                  <div className={cn('sass__slide-content')}>
                    <h3 className={cn('sass__slide-title')}>Automated Calendar Management</h3>
                    <p className={cn('sass__slide-paragraph')}>
                      Overview of departures and arrivals across the entire network, or for specific locations.
                      Colour-coded labels to help track the movement of containers easily. Summary cards that give a
                      glance of the containers in each shipment on each day.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className={cn('sass__slide')}>
                  <img
                    src="/images/pages/DigitalTools/CargoesFlow/visibility.png"
                    alt="shipment visibility"
                    className={cn('sass__slide-image')}
                  />
                  <div className={cn('sass__slide-content')}>
                    <h3 className={cn('sass__slide-title')}>Shipment Visibility</h3>
                    <p className={cn('sass__slide-paragraph')}>
                      End-to-end tracking across land, air and sea. Enhanced with DP World's terminal events Exception
                      management, alerts for shipment delays and early arrivals. Managing risks by gaining real-time
                      visibility. Map-based visualization and integration with 3rd party GIS.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className={cn('sass__slide')}>
                  <img
                    src="/images/pages/DigitalTools/CargoesFlow/dashboard.png"
                    alt="shipment visibility"
                    className={cn('sass__slide-image')}
                  />
                  <div className={cn('sass__slide-content')}>
                    <h3 className={cn('sass__slide-title')}>Multi-Level Dashboard</h3>
                    <p className={cn('sass__slide-paragraph')}>
                      A Global glance of all active shipments including exceptions and notifications. Colour coded
                      labels to show the severity of any exception cases. Curser showing near real-time location of the
                      cargo. A card summary that gives a glance of important information related to the shipment such as
                      vessel info, cargo info, tracking chart, ETA etc.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className={cn('sass__slide')}>
                  <img
                    src="/images/pages/DigitalTools/CargoesFlow/analytics.png"
                    alt="shipment visibility"
                    className={cn('sass__slide-image')}
                  />
                  <div className={cn('sass__slide-content')}>
                    <h3 className={cn('sass__slide-title')}>Analytics</h3>
                    <p className={cn('sass__slide-paragraph')}>
                      Charts that help identifying where the inefficiencies occur. Analytics that help the user
                      collaborate with the right business partners. A map that helps view the hot spots of trade. A list
                      of key metrics that summarize the important logistics data points.
                    </p>
                  </div>
                </div>
              </SwiperSlide>

              <div className="slider-navigation-box">
                <div ref={navigationPrev} className="slider-navigation prev"></div>
                <div ref={navigationNext} className="slider-navigation next"></div>
              </div>
            </Swiper>
          )}
        </div>
      </div>
    </section>
  );
};

export default SectionSaas;
